import localForage from 'localforage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

const persistConfig = {
    key: 'root',
    stateReconciler: autoMergeLevel2,
    storage: localForage,
    whitelist: ['authSlice'],
};

export default persistConfig;
